export const notifyError = (notification, msg, title, duration) => {
	notification.error({
		message: title ? title : 'ACTION FAILED',
		description: msg,
		placement: 'topRight',
		duration: duration ? duration : 3.5,
	})
}

export const notifySuccess = (notification, title = `ACTION SUCCESSFUL`, msg) => {
	notification.success({ message: title, description: msg, placement: 'topRight' })
}

export const notifyInfo = (notification, msg, title = `Please Check!`) => {
	notification.info({ message: title, description: msg, placement: 'topRight', duration: 10 })
}

export const NOTIFICATION_VARIANTS = {
	success: {
		color: 'var(--notification-success-color)',
		backgroundColor: 'var(--notification-success-background-color)',
	},
	warning: {
		color: 'var(--notification-warning-color)',
		backgroundColor: 'var(--notification-warning-background-color)',
	},
}

export const showNotification = ({
	notification,
	message,
	variant = 'success',
	color,
	backgroundColor,
	width = 300,
	height = 65,
	closeIcon,
}) => {
	const variantColors = NOTIFICATION_VARIANTS[variant] || NOTIFICATION_VARIANTS.success
	const notificationColor = color || variantColors.color
	const notificationBackgroundColor = backgroundColor || variantColors.backgroundColor

	notification.open({
		message,
		description: null,
		placement: 'topRight',
		duration: 5,
		icon: null,
		style: {
			width: `${width}px`,
			height: `${height}px`,
			color: notificationColor,
			backgroundColor: notificationBackgroundColor,
			border: `1px solid ${notificationColor}`,
			borderRadius: '8px',
			padding: '8px',
			boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
			display: 'flex',
			alignItems: 'center',
			'--notification-color': notificationColor,
		},
		...(closeIcon !== undefined ? { closeIcon } : {}),
		className: 'show-notification',
	})
}
